import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

function RedirectExtrasToVariations() {
  return <Navigate to='/report/extras-variations' replace />;
}

const RestraurantRoutes = [
  {
    path: 'report',
    component: lazy(() => import('views/report')),
  },
  {
    path: 'report/overview',
    component: lazy(() => import('views/report-overview')),
  },
  {
    path: 'report/products',
    component: lazy(() => import('views/report-products')),
  },
  {
    path: 'report/revenue',
    component: lazy(() => import('views/report-revenue')),
  },
  {
    path: 'report/acquisition',
    component: lazy(() => import('views/report-acquisition')),
  },
  {
    path: 'report/retention',
    component: lazy(() => import('views/report-retention')),
  },
  {
    path: 'report/search-terms',
    component: lazy(() => import('views/report-search-terms')),
  },
  {
    path: 'report/product-engagement',
    component: lazy(() => import('views/report-product-engagement')),
  },
  {
    path: 'report/abandoned-carts',
    component: lazy(() => import('views/report-abandoned-carts')),
  },
  {
    path: 'report/orders',
    component: lazy(() => import('views/report-orders')),
  },
  {
    path: 'report/variation',
    component: lazy(() => import('views/report-variation')),
  },
  {
    path: 'report/categories',
    component: lazy(() => import('views/report-categories')),
  },
  {
    path: 'report/stock',
    component: lazy(() => import('views/report-stock')),
  },
  {
    path: 'report/extras-variations',
    component: lazy(() => import('views/report-extras')),
  },
  {
    path: 'report/extras',
    component: RedirectExtrasToVariations,
  },
];

export default RestraurantRoutes;
